<template>
  <select class="form-control" :value="recorrido" @change="$emit('update:recorrido', $event.target.value)" required>
    <option value="" selected disabled>{{placeholder}}</option>
    <option value="0" v-if="all">Todos</option>
    <option v-for="_recorrido in recorridos" :key="_recorrido.id_recorrido" :value="_recorrido.id_recorrido">{{_recorrido.nombre}}</option>
  </select>
</template>

<script>
import {defineComponent, ref} from "vue";
import Swal from "sweetalert2";
import {useApi} from "@/use/useApi";
import useAuth from "@/providers/auth";

export default defineComponent({
  name: "SelectRecorrido",
  props: {
    recorrido: {
      type: String,
      default: ''
    },
    all: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Seleccionar Recorrido'
    }
  },
  setup(){
    const { loading, make } = useApi();
    const recorridos = ref([]);
    const {isCliente} = useAuth();

    async function getRecorridos(){
      loading.message = 'Obteniendo recorridos';
      let {data} = await make('generales/get-recorridos', {});
      if(data === null){
        Swal.fire('Error', 'Ocurrió un error al conectarse con el servidor', 'error');
      } else {
        if(data.error){
          Swal.fire('Error', data.message, 'error');
        } else {
          recorridos.value = data.recorridos;
        }
      }
    }

    getRecorridos();

    return {recorridos, isCliente};
  }
})
</script>

<style scoped>

</style>
